// announce-servers-toggling.js
; (({ $, $$ }) => {
    $$('.js-announce-servers-toggling').forEach(el => {
        const main = el.querySelector('.js-announce-servers-toggling__main')
        const hider = el.querySelector('.js-announce-servers-toggling__hider')
        const toggler = el.querySelector('.js-announce-servers-toggling__toggler')

        if (!main) {
            console.error('js-announce-servers-toggling__main not defined')
            return
        }

        if (!hider) {
            console.error('js-announce-servers-toggling__hider not defined')
            return
        }

        if (!toggler) {
            console.error('js-announce-servers-toggling__toggler not defined')
            return
        }

        const scrollOffset = parseInt(el.dataset.scrollOffset?.trim()) || 0
        const toggleText = toggler.dataset.toggleText
        const initialToggleText = toggler.innerHTML.trim()
        const initialMaxHeight = main.style.maxHeight.trim()
        let expanded = false

        toggler.addEventListener('click', event => {
            (expanded ? (shrink() + scrollToStart()) : expand())
            return false
        })

        function expand() {
            hider.style.display = 'none'
            main.style.maxHeight = 'none'
            toggler.innerHTML = toggleText
            expanded = true
        }

        function shrink() {
            hider.style.display = 'flex'
            main.style.maxHeight = initialMaxHeight
            toggler.innerHTML = initialToggleText
            expanded = false
        }

        function scrollToStart() {
            setTimeout(() => {
                el.scrollToElement(500, scrollOffset)
            }, 10)
        }
    })
})(CNS);